import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Icon} from '@components/common/base/icon'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {useStore} from '@components/subtasks-old/subtasks-store'

const TwAggregatedNumericStickers = tw.div`
  text-secondary
  font-normal
  flex
  items-center
  mr-4
`

const TwIcon = tw.div`
  bg-third-old
  rounded-full
  p-2
  w-[18px]
  h-[18px]
  flex
  items-center
  mr-2
`

export const AggregatedNumericStickers = observer(() => {
  const [, store] = useStore()

  return (
    <>
      {Array.from(store.numericStickersSum).map(
        ([stickerId, {title, value}]) => {
          return (
            <Tooltip key={stickerId} content={title} placement="bottom">
              <TwAggregatedNumericStickers>
                <TwIcon>
                  <Icon type="sticker" icon="IconSum" color="invert" />
                </TwIcon>
                {Number(value).toLocaleString('ru-RU')}
              </TwAggregatedNumericStickers>
            </Tooltip>
          )
        }
      )}
    </>
  )
})
